export enum TagEvent {
  PageView = 'page_view',
  FeedItemVisible = 'feed_item_visible',
  ArticleOpened = 'article_opened',
  ArticleRead = 'article_read',
  FeedItemRead = 'feed_item_read',
  NewsletterFormOpened = 'newsletter_form_opened',
}
